import React from 'react'
import styled from 'styled-components'
import { components, GroupTypeBase, OptionProps } from 'react-select'
import { OptionType } from '../../../types/utilities'
import { NoticeProps, MenuListComponentProps } from 'react-select/src/components/Menu'
import LiveTooltip from 'live/components/ui/tooltip'
import i18n from 'live/services/i18n'
import {Checkbox} from '@intelie/ui'

export const NoOptionsMessage = (props: NoticeProps<OptionType, boolean, GroupTypeBase<OptionType>>): JSX.Element => {
    return (
        <components.NoOptionsMessage {...props}>
            <LiveTooltip
                content={i18n('If some is missing check the recipient groups configured in this report')}
                position={'bottom'}
            >
                <StyledSelectEmptyOptionsComponent className={'SelectEmptyOptionsComponent'}>
                    <i className={'far fa-empty-set SelectEmptyOptionsComponent__icon'} />
                    <span className="SelectEmptyOptionsComponent__text">
                        {i18n('No more recipient groups to select')}
                    </span>
                </StyledSelectEmptyOptionsComponent>
            </LiveTooltip>
        </components.NoOptionsMessage>
    )
}

const StyledSelectEmptyOptionsComponent = styled.div`
    display: flex;
    background-color: ${({ theme }) => theme['gray-0']};
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    .SelectEmptyOptionsComponent {
        &__icon {
            color: ${({ theme }) => theme['gray-500']};
            font-size: 40px;
        }
        &__text {
            font-size: 15px;
            margin-top: 14px;
        }
    }
`

export const Option = (props: OptionProps<OptionType, boolean, GroupTypeBase<OptionType>>): JSX.Element => {
    return (
        <>
            <components.Option {...props}>
                <StyledCustomOption>
                    <div className='StyledCustomOption'>
                        {props.isMulti && (
                            <Checkbox className="StyledCustomOption__checkbox" checked={props.isSelected} onChange={() =>{}}/>
                        )}
                        <span className='StyledCustomOption__label'>
                            {props.children}
                        </span>
                    </div>
                </StyledCustomOption>
            </components.Option>
        </>
    )
}

const StyledCustomOption = styled.div`
    .StyledCustomOption {
        display: flex;
        gap: 4px;
        font: ${({ theme }) => theme['font-semibold']};
        font-size: 13px;
        line-height: 16px;
        &__checkbox {
          
        }
    }
`

export const MenuList = (
    props: MenuListComponentProps<OptionType, boolean, GroupTypeBase<OptionType>>
): JSX.Element => {
    const groupsCount = props.options?.length
    const selectedCount = props.getValue()?.length

    return (
        <>
            {props.isMulti && (
                <StyledCustomMenuListHeader>
                    <div className='StyledCustomMenuListHeader'>
                        <div className='StyledCustomMenuListHeader__globalCheckbox'>
                            <div className='StyledCustomMenuListHeader__globalCheckbox__checkbox'>
                                <Checkbox
                                    checked={selectedCount == groupsCount} 
                                    indeterminate={selectedCount > 0 && selectedCount < groupsCount}
                                    onChange={() => {
                                        if(!props.hasValue) props.setValue(props.options)
                                        else props.clearValue()
                                    }}
                                    
                                />
                            </div>
                            <span className='StyledCustomMenuListHeader__globalCheckbox__label'>
                                {`${props.hasValue ? i18n('Unselect all') : i18n('Select all')} ${groupsCount ?? ''} ${i18n('groups')}`}
                            </span>
                        </div>
                        <div className='StyledCustomMenuListHeader__headerText'>
                            <span>{`Recipient Groups (${selectedCount ?? ''} of ${groupsCount ?? ''})`}</span>
                        </div>
                    </div>
                </StyledCustomMenuListHeader>
                
            )}
            <components.MenuList {...props} />
        </>
    )
}

const StyledCustomMenuListHeader = styled.div`
    .StyledCustomMenuListHeader{
        height: 65px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 8px 12px;
        font-size: 13px;
        &__globalCheckbox {
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: 4px;
            justify-content:flex-start
            &__checkbox{
               
            }
            &__label {
                height: 20px;
                font: ${({ theme }) => theme['font-semibold']};
                font-size: 100%;
                line-height: 16px;
                margin-bottom: -1%;
            }
        }
        &__headerText {
            color: ${({ theme }) => theme['gray-800']};
            font-family: ${({ theme }) => theme['font-semibold']};
            font-weight: 600;
            font-size: 100%;
            line-height: 16px;
            margin-bottom: -1%;
        }
    }
        
`;
